import { TFunction } from "i18next";
import { Setting } from "model/Workgroup";

export type CompanySettingsV2PageKey =
  | "profile"
  | "details"
  | "users"
  | "Customers"
  | "Ob"
  | "Subscription"
  | "System";

export interface CompanySettingsV2MenuItem {
  readonly iconName: string;
  readonly label: string;
  readonly page: CompanySettingsV2PageKey;
}

const hasEnabledSetting = (settings: Setting[], key: string): boolean => {
  return settings.some((setting: Setting) => {
    return setting.key === key && setting.value === "true";
  });
};

export const getCompanySettingsV2MenuItems = (
  t: TFunction,
  settings: Setting[],
): CompanySettingsV2MenuItem[] => {
  const baseItems: CompanySettingsV2MenuItem[] = [
    {
      page: "profile",
      label: t("ProfileCompany.Profile"),
      iconName: "v2/person",
    },
    {
      page: "details",
      label: t("ProfileCompany.Details"),
      iconName: "v2/document",
    },
    {
      page: "users",
      label: t("CompanyUsers.CompanyUsers"),
      iconName: "v2/team",
    },
  ];

  const optionalItems: CompanySettingsV2MenuItem[] = [
    ...(hasEnabledSetting(settings, "CustomersEnabled")
      ? [
          {
            page: "Customers" as const,
            label: t("ProfileCompany.Customers"),
            iconName: "v2/roster",
          },
        ]
      : []),
    ...(hasEnabledSetting(settings, "CompanyShowInconvenientModule")
      ? [
          {
            page: "Ob" as const,
            label: t("ProfileCompany.OB"),
            iconName: "v2/clock",
          },
        ]
      : []),
  ];

  return [
    ...baseItems,
    ...optionalItems,
    {
      page: "Subscription",
      label: t("ProfileCompany.Subscription"),
      iconName: "v2/wallet",
    },
    {
      page: "System",
      label: t("System.System"),
      iconName: "v2/settings",
    },
  ];
};

export const parseCompanySettingsV2Page = (
  value: string | null,
): CompanySettingsV2PageKey | null => {
  switch (value) {
    case "profile":
    case "details":
    case "users":
    case "Customers":
    case "Ob":
    case "Subscription":
    case "System":
      return value;
    case null:
      return null;
    default:
      return null;
  }
};
